import { createAction, handleActions, Action } from 'redux-actions'
// Name Spaced Action Types
const INCREMENT = 'NetworkStatus/INCREMENT'
const DECREMENT = 'NetworkStatus/DECREMENT'
export const actions = {
  INCREMENT,
  DECREMENT
}

// createAction is a lib for creating FSAs
// see https://github.com/acdlite/flux-standard-action, for info in the flux standard action
type NetworkStatusActionCreators = {
  increment: number => Action<number>,
  decrement: number => Action<number>
}

export const actionCreators: NetworkStatusActionCreators = {
  increment: createAction(INCREMENT),
  decrement: createAction(DECREMENT)
}

export type NetworkStatusState = {
  connectionCount: number
}
export const initialState: NetworkStatusState = {
  connectionCount: 0
}

export default handleActions(
  {
    [INCREMENT]: (state, action: Action<number>) => ({
      ...state,
      connectionCount: state.connectionCount + 1
    }),
    [DECREMENT]: (state, action: Action<number>) => ({
      ...state,
      connectionCount: state.connectionCount - 1
    })
  },
  initialState
)
export const selectors = {
  networkLoading: (state: NetworkStatusState) => !!state.connectionCount
}



// WEBPACK FOOTER //
// ./src/redux/reducers/networkStatus/networkStatusReducer.js